import { realEstateTypeLabel } from '../../../../../../constants/redeProto';
import { SectionCard } from '../../components/SectionCard';
import { StateFeedback } from '../../components/StateFeedback';
import {
  HeatBadge,
  Table,
  TableWrap,
} from '../../components/StatesTable/styles';
import { heatColor } from '../../theme/tokens';
import {
  EMPTY_VALUE,
  formatCurrency,
  formatInt,
  formatPct,
  truncate,
} from '../../utils/format';
import useTypologies from './useTypologies';

export function Typologies(): JSX.Element {
  const { typologies, loading, error } = useTypologies();

  return (
    <StateFeedback
      loading={loading}
      error={error}
      empty={typologies.length === 0}
    >
      <SectionCard
        title="Tipologias atendidas"
        subtitle="Habilitação, meta e cobertura por tipologia do edital"
      >
        <TableWrap>
          <Table>
            <thead>
              <tr>
                <th>Tipologia</th>
                <th>Edital</th>
                <th className="num">Preço</th>
                <th>Tipos de imóvel</th>
                <th className="num">Habilitados</th>
                <th className="num">Meta</th>
                <th className="num">Atingimento</th>
                <th>Regiões descobertas</th>
              </tr>
            </thead>
            <tbody>
              {typologies.map((typology) => (
                <tr key={typology.typologyGroupId}>
                  <td>
                    <strong title={typology.name}>
                      {truncate(typology.name, 28)}
                    </strong>
                  </td>
                  <td title={typology.noticeName ?? undefined}>
                    {truncate(typology.noticeName, 24)}
                  </td>
                  <td className="num">{formatCurrency(typology.price)}</td>
                  <td>
                    {typology.realEstateTypes.length === 0
                      ? EMPTY_VALUE
                      : typology.realEstateTypes
                          .map((type) => realEstateTypeLabel(type))
                          .join(', ')}
                  </td>
                  <td className="num">
                    {formatInt(typology.qualifiedAccredited)}
                  </td>
                  <td className="num">{formatInt(typology.goal)}</td>
                  <td className="num">
                    <HeatBadge color={heatColor(typology.achievement)}>
                      {formatPct(typology.achievement, 0)}
                    </HeatBadge>
                  </td>
                  <td>
                    {typology.uncoveredRegions.length === 0
                      ? EMPTY_VALUE
                      : typology.uncoveredRegions.join(', ')}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrap>
      </SectionCard>
    </StateFeedback>
  );
}
